import { render, staticRenderFns } from "./itemScanComponent.vue?vue&type=template&id=54603f97&scoped=true&"
import script from "./itemScanComponent.vue?vue&type=script&lang=js&"
export * from "./itemScanComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54603f97",
  null
  
)

export default component.exports